
//#region src/types/model/types.ts
/**
* Type identifier for a custom type field.
*/
const CustomTypeModelFieldType = {
	Boolean: "Boolean",
	Color: "Color",
	Date: "Date",
	Embed: "Embed",
	GeoPoint: "GeoPoint",
	Group: "Group",
	Image: "Image",
	Integration: "IntegrationFields",
	Link: "Link",
	Number: "Number",
	Select: "Select",
	Slices: "Slices",
	StructuredText: "StructuredText",
	Table: "Table",
	Text: "Text",
	Timestamp: "Timestamp",
	UID: "UID",
	IntegrationFields: "IntegrationFields",
	Range: "Range",
	Separator: "Separator",
	LegacySlices: "Choice"
};

//#endregion
exports.CustomTypeModelFieldType = CustomTypeModelFieldType;
//# sourceMappingURL=types.cjs.map